import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CarrierMappingRead } from '@ragu-components/ord-types';

const CarrierMappingsList = React.lazy(async () => import('./CarrierMappingsList'));

export const carrierMappingsResource: OrdResourceProps = {
  key: Resources.carrier_mappings,
  name: Resources.carrier_mappings,
  list: <CarrierMappingsList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: CarrierMappingRead) => record.name,
};
